/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

export interface IRemoteConfig {
  // App Management
  interval: number;
  maintenance: boolean;
  maintenanceParams: MaintenanceParams;
  quotePriceMin: number;
  version: string;
  versionIsIgnored: boolean;
  authorisationTimeouts: AuthorisationTimeouts;

  // Feature Flags
  atomicEnabled: boolean;
  atomicPromotionsEnabled: boolean;
  drawdownFulfilmentEnabled: boolean;
  magnesiumPromoEnabled: boolean;
  quoteEnabled: boolean;
  activitiesEnabled: boolean;
  seedEnabled: boolean;
  traderSpecialsEnabled: boolean;
  ponchoTreatmentEnabled: boolean;
  seedStorePickupEnabled: boolean;
  // Pilots
  activitiesPilotUsers: {
    emails: string[];
  };

  // In-App Urls
  privacyPolicyUrl: string;
  termsAndConditionsUrl: string;
}

export interface RemoteConfigState extends Required<IRemoteConfig> {
  [key: string]: string | boolean | number | object | undefined;
}

export interface MaintenanceParams {
  heading: string;
  message: string;
}

export interface AuthorisationTimeouts {
  getAccounts: number;
  getAccountDetails: number;
  getUserDetails: number;
  getAtomicToken: number;
}

export enum ErrorCode {
  ServiceUnavailable = 'urn:errors:service-unavailable',
}

export type ServiceUnavailableResponse = {
  type: 'urn:errors:service-unavailable';
  status: 503;
  detail: 'In maintenance';
};
